import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import phoneCallIllustrationIconImage from '../../assets/phone_call_illustration_icon.png'
import { tID } from '../../utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

export const PhoneCallIllustrationIcon: FunctionComponent<PhoneCallIllustrationIconProps> = ({ size = 48 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      size={sizeInPixels}
      testID={`${tID('PhoneCallIllustration')}`}
      source={phoneCallIllustrationIconImage as ImageSourcePropType}
    />
  )
}

type PhoneCallIllustrationIconProps = {
  size?: number
}
